import { ConfigProvider } from "antd";

const ThemeProvider = ({
  children,
  isDarkMode = false,
  primaryColor = "#1677ff",
}) => {
  return (
    <ConfigProvider
      theme={{
        // algorithm: isDarkMode ? theme.darkAlgorithm : theme.defaultAlgorithm,
        token: {
          colorPrimary: "#021B79", // Dark gray primary color
          // colorText: '#ffffff', // White text for contrast
          colorBorder: "#021B79", // Gray border
          borderRadiusLG: 12, // Slightly rounded modal
        },
        components: {
          Input: {
            paddingBlock: 5, // Vertical padding
            paddingInline: 10, // Horizontal padding
            colorPrimary: "#021B79", // Red border when focused
            colorPrimaryHover: "#021B79", // Slightly lighter red on hover
            lineWidthFocus: 2, // Border thickness when focused
            inputFontSize: 14,
          },
          Form: {
            labelFontSize: 13, // Increase label font size
            labelColor: "#333", // Optional: Change label color
            labelFontWeight: 600, // Optional: Make label bold
          },
          Select: {
            paddingBlock: 10, // Vertical padding
            paddingInline: 10, // Horizontal padding
            colorPrimary: "#000000",
            colorPrimaryHover: "#000000",
            lineWidthFocus: 3,
            inputFontSize: 14,
            optionFontSize: 16,
            // borderRadius: 1,
            optionSelectedBg: "#949699",
            optionSelectedColor: "#ffffff",
          },
          DatePicker: {
            activeBorderColor: "#5379c6",
          },
          Menu: {
            itemSelectedBg: "#000000", // Set the selected item background color
            itemSelectedColor: "#ffffff", // (Optional) Change selected text color
            itemHoverBg: "#919191", // (Optional) Change hover background color
            // subMenuItemBg: "#b7b9bc", // Custom background for submenu
          },
          Modal: {
            // contentBg: '#1a1a1a', // Dark gray modal background
            // headerBg: '#111111', // Even darker header
            // titleColor: '#ffffff', // White title text
            // footerBg: '#1a1a1a', // Matching footer
          },
          Button: {
            // defaultBg: "#4CAF50",  // Background color for default buttons
            defaultColor: "#5f4cb3", // Text color
            defaultBorderColor: "#5f4cb3", // Border color
            // defaultHoverBg: "#45A049", // Hover background color
            // defaultHoverColor: "white",
            defaultHoverBorderColor: "#5f4cb3",
          },
        },
      }}
    >
      {children}
    </ConfigProvider>
  );
};

export default ThemeProvider;
